define("shared/modifiers/track", ["exports", "@ember/debug", "@ember/service", "ember-modifier"], function (_exports, _debug, _service, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/service",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  /**
   *
   * @class TrackModifier
   * @extends Modifier
   *
   * This handles making track calls using the segment service which calls the segment.io API
   * https://segment.com/docs/connections/spec/track/
   *
   * Positional Parameters:
   * @param {String} name The name of the event to track
   * @param {String} event The event type to listen for (or `install` to track when modifier installed)
   *
   * Named Parameters:
   * @param {Any} * Any number of named parameters will be added to the segment.track payload
   *
   * Examples:
   *
   * Simple Usage:
   *
   * ```
   * <div {{track "name-of-segment-event" "mousedown" feature="conversations"}}>
   * </div>
   *
   * Note: Automatically sends the auth.currentSocialProfile as part of the payload.
   * Override by passing your own social_profile
   * ```
   */
  let TrackModifier = _exports.default = (_dec = (0, _service.inject)(), _dec2 = (0, _service.inject)(), (_class = class TrackModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
    }
    get name() {
      return this.args.positional[0];
    }
    get event() {
      const secondArg = this.args.positional[1];
      if (secondArg === 'install') {
        return undefined;
      }
      return secondArg;
    }
    get defaults() {
      return {
        social_profile: this.auth.currentSocialProfile?.id ? this.auth.currentSocialProfile : undefined
      };
    }
    get payload() {
      return {
        ...this.defaults,
        ...this.args.named
      };
    }
    didReceiveArguments() {
      if (this.event) {
        this.removeEventListener();
        this.handler = () => {
          if (this.element.hasAttribute('aria-disabled')) {
            return;
          }
          this.segment.track(this.name, this.payload);
        };
        this.addEventListener();
      }
    }
    willRemove() {
      this.removeEventListener();
    }
    didInstall() {
      (false && !(this.name) && (0, _debug.assert)('Must provide event name to track', this.name));
      if (!this.event || this.args.positional[1] === 'install') {
        this.segment.track(this.name, this.payload);
      }
    }
    addEventListener() {
      this.element.addEventListener(this.event, this.handler);
    }
    removeEventListener() {
      if (this.name && this.event && this.handler) {
        this.element.removeEventListener(this.event, this.handler);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
});